export * from './PlusIcon';
export * from './PlusIcon16Light';
export * from './PlusIcon16Regular';
export * from './PlusIcon16Solid';
export * from './PlusIcon20Light';
export * from './PlusIcon20Regular';
export * from './PlusIcon20Solid';
export * from './PlusIcon24Regular';
export * from './PlusIcon24Solid';
export * from './PlusIcon32Regular';
export * from './PlusIcon64Regular';
